{
  "dismiss": "Lõpeta"
}
